export type SessionLike = {
  grantsAll?: boolean;
  permissions?: string[] | null;
} | null | undefined;

/**
 * Autorización de UI alineada con session TH-003.
 * grantsAll → allow. Si no, membership en permissions.
 */
export function can(
  permissionCode: string,
  session: SessionLike,
): boolean {
  if (!permissionCode) {
    return false;
  }
  if (session?.grantsAll === true) {
    return true;
  }
  const permissions = session?.permissions;
  return Array.isArray(permissions) && permissions.includes(permissionCode);
}
